import React from 'react';

class NoResults extends React.Component {

  render() {
    var name = this.props.name || '',
        msg = this.props.msg || '',
        defaultMsg = 'No results are found in <strong>' + name + '</strong>';

    return <p className="no-result" dangerouslySetInnerHTML={{__html: msg.length === 0 ? defaultMsg : msg}} />;
  }
}

NoResults.propTypes = {
  name: React.PropTypes.string,
  msg:  React.PropTypes.string
};

export default NoResults;
